import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ImageGenerateRequest {
  prompt: string;
}

export interface ImageGenerateResponse {
  generation_id: string;
  prompt: string;
  image_url: string;
  created_at: string;
  in_use?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ImageGenerationService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/images`;

  generate(prompt: string): Observable<ImageGenerateResponse> {
    const payload: ImageGenerateRequest = { prompt };
    return this.http.post<ImageGenerateResponse>(`${this.baseUrl}/generate`, payload);
  }

  history(limit = 30): Observable<ImageGenerateResponse[]> {
    const params = new HttpParams().set('limit', String(limit));
    return this.http.get<ImageGenerateResponse[]>(`${this.baseUrl}/history`, { params });
  }

  delete(generationId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${generationId}`);
  }
}

